export default class AuthTwoFactorTokenRequest {
  public key: string;
  public secret: string;
  public token: string;
  public remember: boolean;

  constructor(options) {
    this.key = options.key;
    this.secret = options.secret;
    this.token = options.token;
    this.remember = options.remember;
  }
}
